module.exports = __webpack_public_path__ + "media/images/landingTeaser__bg-53f97537677b35401d54e5a97c349722.jpg";